import TheLayout from '@/components/TheLayout'
import SiteListView from '@/views/site/list/SiteListView.vue'
import PageNotFound from '@/views/static/PageNotFound'
import SiteRouter from './sites'
import mapPanelRoutes from './utils/mapPanelRoutes'
import { mustBeAuthenticated } from './utils/mustBeAuthenticated'
import { MountGuard } from '@/httpClient'
import { logout } from './utils/logout'

// Arquivo de rotas global que será usado como parâmetro de configuração do Design System
const routes = [
  {
    path: '/',
    component: TheLayout,
    children: [
      {
        name: 'siteList',
        path: '/',
        title: 'site.list.title',
        component: SiteListView
      },
      {
        name: 'logout',
        path: '/logout',
        title: 'Logout',
        beforeEnter: MountGuard(logout)
      },
      ...mapPanelRoutes(SiteRouter)
    ],
    beforeEnter: MountGuard(mustBeAuthenticated)
  },
  {
    path: '*',
    component: TheLayout,
    children: [
      {
        path: '*',
        name: 'not-found',
        component: PageNotFound,
        title: 'static.notFound.title'
      }
    ]
  }
]

export default routes
